import { render, staticRenderFns } from "./TransferCard.vue?vue&type=template&id=76a4f620&scoped=true"
import script from "./TransferCard.vue?vue&type=script&lang=js"
export * from "./TransferCard.vue?vue&type=script&lang=js"
import style0 from "./TransferCard.vue?vue&type=style&index=0&id=76a4f620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a4f620",
  null
  
)

export default component.exports